module.exports = __webpack_public_path__ + "static/media/houselt55.f44d6dc3.svg";